import React, { ReactElement } from 'react'
import { Typography } from '@which/seatbelt'
import './intro-paragraph.scss'

interface Props {
  text: string
}

const IntroParagraph = ({ text = '' }: Props): ReactElement => {
  return text ? (
    <Typography className="w-intro-paragraph-wrapper" tag="p" textStyle="body-intro">
      {text}
    </Typography>
  ) : null
}

export default IntroParagraph
